import type { LocateProvider, LocateProviderResponse } from '@thinkalpha/ui-types/contracts/locates/providers';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const axios = createInstance({ baseURL: appConfig.locatesApi });

export async function getLocatesProviders(): Promise<LocateProvider[]> {
    const { data } = await axios.get<LocateProviderResponse>('/providers');
    return data.providers;
}
